"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCacheItem = exports.getCacheItem = exports.clearCache = exports.addItemToCache = void 0;
let cache = null;
const instance = () => {
  if (!cache) {
    cache = new Map();
  }
  return cache;
};
const addItemToCache = (key, value) => {
  instance().set(key, value);
};
exports.addItemToCache = addItemToCache;
const removeCacheItem = key => {
  instance().delete(key);
};
exports.removeCacheItem = removeCacheItem;
const getCacheItem = key => {
  return instance().get(key);
};
exports.getCacheItem = getCacheItem;
const clearCache = () => {
  instance().clear();
};
exports.clearCache = clearCache;